<div class="body" [formGroup]="formGroup">

    <div class="sidenav-wrapper">

        <app-sidenav></app-sidenav>

    </div>

    <div @show class="content">

        <div class="content-row-2">

            <div class="section-wrapper customer-data-wrapper">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">person</mat-icon>

                    <span class="text">
                        Kopfdaten
                    </span>

                    <span class="spacer"></span>

                    <button *ngIf="addressControl.valid" mat-icon-button matTooltip="Kontaktinformation anlegen"
                        (click)="addContactInformation()">
                        <mat-icon>add</mat-icon>
                    </button>

                </div>

                <div class="section-content">


                    <div class="header-data-wrapper">

                        <app-contact-form [editMode]="!disabled" formGroupName="contact"></app-contact-form>

                        <div class="contact-information-wrapper">

                            <div class="contact-information-table-wrapper">
                                <app-contact-information-table
                                    *ngIf="contactInformationControl.length > 0; else noContactInformation"
                                    [disabled]="disabled" formArrayName="contactInformation">
                                </app-contact-information-table>
                            </div>

                        </div>

                    </div>

                    <app-concurrency-label [entityIsSupported]="false"></app-concurrency-label>

                </div>
            </div>

            <div class="section-wrapper address-data-wrapper">

                <div class="section-headline optional">

                    <mat-icon class="main-icon">location_on</mat-icon>

                    <span class="text">
                        Adresse
                    </span>

                    <span class="spacer"></span>

                    <button *ngIf="addressControl.valid" mat-icon-button matTooltip="Adresse auf Karte anzeigen"
                        (click)="showAddress()">
                        <mat-icon>map</mat-icon>
                    </button>

                </div>

                <div class="section-content">

                    <app-address-form formGroupName="address" [appearance]="appearance" style="flex: 1; width: 100%;"
                        [editMode]="!disabled"></app-address-form>

                </div>

            </div>

        </div>

        <div class="section-wrapper">

            <div class="section-headline optional">

                <mat-icon class="main-icon">domain</mat-icon>

                <span class="text">
                    Kundenzuordnungen
                </span>

                <span class="spacer"></span>

                <button *ngIf="!disabled" mat-icon-button matTooltip="Weiterem Kunden zuordnen" (click)="linkToCustomer()">
                    <mat-icon>add</mat-icon>
                </button>

                <button *ngIf="!disabled" mat-icon-button matTooltip="Neuen Kunden anlegen" (click)="createCustomer()">
                    <mat-icon>domain_add</mat-icon>
                </button>

            </div>

            <app-customer-table></app-customer-table>

        </div>

    </div>

</div>

<ng-template #noContactInformation>

    <div class="no-contactinformation-hint">

        Keine Kontaktinformationen

    </div>

</ng-template>